module.exports = __webpack_public_path__ + "img/payment_deferral_promo.f4927506.jpg";